import React, { Component } from 'react';

export class WelcomeScreen extends Component {
  render() {
    return (
      <div>
        <div style={{ height: this.props.height, position: 'relative' }}>
          <div style={{ height: '0.5%', width: '100%' }} />
          <div
            style={{
              height: '100%',
              position: 'relavtive'
            }}
          >
            <div
              className="welcome col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
              style={{ textShadow: '2px 2px 8px #888888' }}
            >
              <p className="title">
                <br />R<span style={{ fontSize: 20 }}>eference&nbsp;</span>
                <span
                  style={{
                    fontSize: 12,
                    writingMode: 'vertical-rl',
                    transform: 'rotate(180deg)'
                  }}
                ></span>
                D<span style={{ fontSize: 20 }}>ata&nbsp;</span>G
                <span style={{ fontSize: 20 }}>rid</span>&nbsp;
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WelcomeScreen;
